import React, { Dispatch, SetStateAction } from "react";
import { Box, Button, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { Activity } from "myfitworld-model";
import ReactionImage from "../ReactionImage";
import { useIntl } from "react-intl";
import getLocalizedProperty from "src/utils/getLocalizedProperty";
import CloseIcon from "@material-ui/icons/Close";
import chatMessages from './messages';
import useChatStyles from "./chatStyles";
import { useMfwThemeProvider } from "myfitworld-utils";

const ReplyActivity = ({replyActivity, setReplyActivity} : ReplyActivityProps) => {
    const {formatMessage, locale} = useIntl();
    const {mfwMobTheme, mfwMuiWebTheme} = useMfwThemeProvider();
    const classes = useChatStyles({mfwTheme: mfwMobTheme});
    const isMobile = useMediaQuery(mfwMuiWebTheme.breakpoints.down('sm'));
    const TEXT_LENGTH = isMobile ? 50 : 60;

    return (
        <Box 
            className={classes.replyActivityBox}
        >
            <Box className={classes.rowSpace}>
                <Box className={isMobile ? classes.column : classes.row}>
                    <Box className={classes.row}>
                        {replyActivity?.reaction && <ReactionImage reaction={replyActivity.reaction}/>}
                        <Typography variant="h6" style={{marginLeft: 5}}>{formatMessage(chatMessages.workout_completed).toUpperCase()} {isMobile ? '' : '-'}</Typography>
                    </Box>
                    {replyActivity?.workout?.title &&
                        <Typography className={classes.dateText}>&nbsp;
                            {
                                getLocalizedProperty(locale, replyActivity?.workout?.title).length > TEXT_LENGTH ? 
                                    `${getLocalizedProperty(locale, replyActivity?.workout?.title).slice(0, TEXT_LENGTH)}...` 
                                    : getLocalizedProperty(locale, replyActivity?.workout?.title)
                            }
                        </Typography>
                    }
                </Box>
                <Button
                  size="small"
                  startIcon={<CloseIcon/>}
                  onClick={_ => setReplyActivity && setReplyActivity(undefined)}
                />
            </Box>
            <Typography className={classes.messageText}>{replyActivity?.text}</Typography>
        </Box>
    )
};
export default ReplyActivity;

interface ReplyActivityProps {
    replyActivity: Activity,
    setReplyActivity: Dispatch<SetStateAction<Activity|undefined>>|undefined;


}